import { render } from "./Search.vue?vue&type=template&id=52fd2f37&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=52fd2f37&scoped=true&lang=css"

import exportComponent from "/Data/maps/detention/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fd2f37"]])

export default __exports__